<template>
  <button-base
    variant="danger"
    color="color-text-inverted"
    :test-id="testId"
    v-bind="{ ...$attrs }">
    <!-- @slot Inner button content -->
    <slot></slot>
  </button-base>
</template>

<script>
import { ButtonBase } from '@/components';
import testable from '@/components/mixins/testable';

/**
 * Button Base with hard-coded "danger" variant
 * @displayName Error Button
 */
export default {
  name: 'ErrorButton',
  components: {
    ButtonBase
  },
  mixins: [testable]
};
</script>
